export default __webpack_public_path__ + "static/media/bnb-prompt-coins.6cf95786.png";